/**eslint-disable*/

import Vue from "vue";
import Vuex from "vuex";

import kycDetails from "./modules/kycDetails";
import kycLogin from "./modules/kycLogin";
import ckycDetails from "./modules/ckycDetails";
import videoDetails from "./modules/videoDetails";
import signatureDetails from "./modules/signature"
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    kycDetails,
    kycLogin,
    ckycDetails,
    videoDetails,
    signatureDetails
  }
});
